import { useState } from 'react';

export default function SectionContact() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10">
          <div className="flex flex-col md:flex-row gap-10">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">联系我们</h2>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                如果您有影片需求、合作意向或使用问题，欢迎通过以下方式与我们取得联系。我们的内容团队和客服团队将在24小时内回复。
              </p>
              <div className="mt-6 space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">商务合作 / 内容反馈</p>
                    <p className="text-sm font-medium text-foreground-800">feedback@seyingshi.tv</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-lg text-accent-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">客服支持</p>
                    <p className="text-sm font-medium text-foreground-800">help@seyingshi.tv</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-secondary-500/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-movie-line text-lg text-secondary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">求片投稿</p>
                    <p className="text-sm font-medium text-foreground-800">request@seyingshi.tv</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                <p className="text-sm font-semibold text-foreground-800 mb-1">快速反馈</p>
                <p className="text-xs text-foreground-500 mb-4">
                  想看的影片片库没有？遇到播放问题？留言告诉我们
                </p>
                {submitted ? (
                  <div className="text-center py-8">
                    <div className="w-14 h-14 rounded-full bg-primary-500/10 flex items-center justify-center mx-auto mb-3">
                      <i className="ri-check-line text-2xl text-primary-500"></i>
                    </div>
                    <p className="text-sm font-medium text-foreground-800">感谢您的反馈！</p>
                    <p className="text-xs text-foreground-500 mt-1">我们会尽快处理您的留言</p>
                  </div>
                ) : (
                  <a
                    href="mailto:feedback@seyingshi.tv"
                    onClick={() => setSubmitted(true)}
                    className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-send-plane-line"></i>
                    发送反馈
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}